import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-md);
  background: var(--card-bg);
  border: 1px solid var(--gray-200);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  padding: var(--space-lg);
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: var(--border-radius-md);
  background: var(--primary-50);
  color: var(--primary-700);
  flex-shrink: 0;

  svg {
    width: 1.375rem;
    height: 1.375rem;
  }
`;

export const StatValue = styled.p`
  margin: 0;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  line-height: 1.2;
`;

export const StatLabel = styled.p`
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--space-md);
  margin-bottom: var(--space-xl);
`;

interface StatCardProps {
  value: React.ReactNode;
  label: React.ReactNode;
  /** Icona lucide opzionale. */
  icon?: React.ReactNode;
  className?: string;
}

/** Scheda indicatore: <StatCard icon={<Users />} value={42} label="Utenti" /> */
export const StatCard: React.FC<StatCardProps> = ({ value, label, icon, className }) => (
  <Box className={className}>
    {icon && <IconWrap>{icon}</IconWrap>}
    <div>
      <StatValue>{value}</StatValue>
      <StatLabel>{label}</StatLabel>
    </div>
  </Box>
);

export default StatCard;
